export default __webpack_public_path__ + "static/media/LGBTInfog.9499d95c.png";